export const isSharedArrayBufferSupports = () => {
  return Boolean(window.SharedArrayBuffer);
};
